var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"body"},[_c('div',[_c('themed-table',{attrs:{"headers":_vm.activeThemedTable.key && _vm.configThemedTables[_vm.activeThemedTable.key] ? _vm.configThemedTables[_vm.activeThemedTable.key].headers : [],"data":_vm.transformedData,"pagination":{
                perPage: _vm.configThemedTables[_vm.activeThemedTable.key].query.limit,
                total: _vm.configThemedTables[_vm.activeThemedTable.key].total
            },"sortingEnabled":false,"filteringEnabled":false,"paginationEnabled":true},on:{"paginationChange":(event) => {
                _vm.configThemedTables[_vm.activeThemedTable.key].query.skip = _vm.configThemedTables[_vm.activeThemedTable.key].query.limit * (event.page - 1);
                _vm.configThemedTables[_vm.activeThemedTable.key].query = {..._vm.configThemedTables[_vm.activeThemedTable.key].query};
            },"searchChange":(event) => {
                const query = _vm.configThemedTables[_vm.activeThemedTable.key].query;
                query.skip = 0; // Resets skip as the search params change
                Object.keys(event).forEach((key) => {
                    if (event[key] && event[key].length >= 3) query[key] = event[key];
                    else delete query[key];
                })
                
                _vm.configThemedTables[_vm.activeThemedTable.key].query = {...query};
            }}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageHeader page-header__flex"},[_vm._v("\n    Participants"),_c('br')])
}]

export { render, staticRenderFns }